import * as React from "react";

type WindowSize = { width: number | null };

const useWindowSize = (): WindowSize => {
    const isBrowser = typeof window !== "undefined";

    const [windowSize, setWindowSize] = React.useState<WindowSize>(() => ({
        width: isBrowser ? window.innerWidth : null, // null on SSR
    }));

    React.useEffect(() => {
        if (!isBrowser) {return;}

        const handleResize = () => setWindowSize({ width: window.innerWidth });

        // Set once before paint
        handleResize();

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [isBrowser]);

    return windowSize;
};

export default useWindowSize;
